import {createApp} from 'vue'
import FrivilligeShopWrongRoleModal from './FrivilligeShopWrongRoleModal'

const el = '.kb-component--frivillige-shop-wrong-role-modal'

export default function(Store){
    const DOM = document.querySelectorAll(el)
    if(DOM.length){
        DOM.forEach((FrivilligeShopWrongRoleModalDOM)=>{
            const component = createApp(FrivilligeShopWrongRoleModal).use(Store)
            component.mount(FrivilligeShopWrongRoleModalDOM)
        })
    }
}